module.exports = __webpack_public_path__ + "static/media/cghs_logo.45174bfb.png";